class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
      document.dispatchEvent(new CustomEvent('applyColorBadges'));
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    this.cartDrawer = document.querySelector(('cart-drawer'));

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    this.onChangeVariantRecommadation();

    this.ELM_openCartDrawer = document.querySelectorAll('[data-open-cart-drawer]');
    this.ELM_openCartDrawer.forEach(elm => {
      elm.addEventListener('click', e => {
        this.cartDrawer.open();
      });
    });
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onNotiAddToCart(html, itemCount) {
    const ELM_notiAddToCart = document.querySelector('[data-presale-noti-add-to-cart]');
    if (!ELM_notiAddToCart) return;
    const ELM_notiCartCount = ELM_notiAddToCart.querySelector('.cart-item-count');
    let cartCount = 0;

    html && (cartCount = html.querySelector('.cart-item-count').innerHTML);
    itemCount && (cartCount = itemCount);

    ELM_notiCartCount.innerHTML = cartCount.toString();
    ELM_notiAddToCart.classList.add('show');
    cartCount == 0 && ELM_notiAddToCart.classList.remove('show');
  }

  onCartUpdate() {
    console.log('onCartUpdate')
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          html && this.onNotiAddToCart(html);
          this.onChangeVariantRecommadation();
          this.onUpdateFreeItemButton();
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
          this.onChangeVariantRecommadation();
          this.onUpdateFreeItemButton();
        })
        .catch((e) => {
          console.error(e);
        });

      fetch(`${routes.cart_url}?section_id=main-cart-footer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const ELM_sourceHTML = html.querySelector('.js-contents');
          const ELM_mainCartFooter = document.getElementById('main-cart-footer');
          const targetHtml = ELM_mainCartFooter.querySelector('.js-contents');
          targetHtml.innerHTML = ELM_sourceHTML.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
    document.dispatchEvent(new CustomEvent('applyColorBadges'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateBottlesCollected() {
    let numberBottlesCollected = 0;

    setTimeout(() => {
      this.querySelectorAll('.cart-item').forEach(elm => {
        numberBottlesCollected += Number(elm.dataset.bottlesCollected || 0);
      });

      if (document.getElementById('bottles-collected')) {
        document.getElementById('bottles-collected').innerHTML = numberBottlesCollected.toString();
      }
      if (document.getElementById('main-cart-footer-bottles-collected')) {
        document.getElementById('main-cart-footer-bottles-collected').classList.toggle('is-empty', numberBottlesCollected === 0);
      }
    }, 1000);
  }

  updateMasterId(ELM_cardWrapper, currentId) {
    const currentVariant = this.getVariantData(ELM_cardWrapper).find((variant) => variant.id == currentId);
   return currentVariant;
  }

  getVariantData(ELM_cardWrapper) {
    const variantData = JSON.parse(ELM_cardWrapper.querySelector('[type="application/json"]').textContent);
    return variantData;
  }

  onChangeVariantRecommadation() {
    const ELM_cartUpsells = document.querySelectorAll('.cart-upsell');
    if (!ELM_cartUpsells) return;
    ELM_cartUpsells.forEach(upsell => {
      upsell.querySelectorAll('.product-card-wrapper').forEach(item => {
        const ELM_selectOption = item.querySelector('[name="select-variant"]');
        const ELM_productForm = item.querySelector('product-form form');
        const ELM_prices = item.querySelectorAll('.price__container');
        let additionalPriceArr = [];
        let currentAdditionPrice = '';
        const additionalPrice = item.dataset.additionalPrice;
        additionalPriceArr = [...additionalPrice.split('|')];

        if(!ELM_selectOption) return;
        ELM_selectOption.addEventListener('change', e => {
          const variantId = e?.target?.value;
          const imageId = ELM_selectOption.options[ELM_selectOption.selectedIndex].dataset.imageId;

          if (ELM_productForm && variantId) {
            ELM_productForm.querySelector('[name=id]').value = variantId;

            if (imageId) {
              const ELM_medias = item.querySelectorAll('.media');
              const ELM_selectedMedia = upsell.querySelector(`#media--${imageId}`);

              if (ELM_selectedMedia) {
                ELM_medias?.forEach(media => {
                  media.style.display = 'none'
                });
                ELM_selectedMedia.style.display = 'block';
              }
            }
          }

          const currentVariant = this.updateMasterId(item, variantId);
          if (additionalPriceArr.length) {
            let selectedAddtionalPrice = '';
            for (let i = 0; i < additionalPriceArr.length; i++) {
              if (additionalPriceArr[i].includes(currentVariant.id)) {
                selectedAddtionalPrice = additionalPriceArr[i];
              }
            }

            if (selectedAddtionalPrice) {
              const selectedAddtionalPriceArr = selectedAddtionalPrice.split('-');
              currentAdditionPrice = selectedAddtionalPriceArr[1];
            }
          }

          if(!ELM_prices.length) return;
          ELM_prices.forEach(elm => {
            let additionPriceHtml = '';
            let priceText = currentVariant.price > 0 ? `${(currentVariant.price / 100)}` : 'FREE';
            if (isFloat(Number(priceText))) {
              priceText = Number(priceText).toFixed(2);
            }
            if (currentAdditionPrice) {
              additionPriceHtml += `<span class="price__additional render-price-additional">/ ${currentAdditionPrice}</span>`;
            }
            if (priceText === 'FREE') {
              elm.innerHTML = 'FREE';
            } else {
              if (elm.querySelectorAll('[data-update-price]')?.length) {
                elm.querySelectorAll('[data-update-price]').forEach(item => {
                  item.innerHTML = `<span class="price-item price-item--sale price-item--last">$${priceText}</span>${additionPriceHtml}`;
                });
              } else {
                elm.innerHTML =`<span class="price-item price-item--sale price-item--last">$${priceText}</span>${additionPriceHtml}`;
                if (currentVariant.compare_at_price) {
                  let compareAtPrice = Number(currentVariant.compare_at_price) / 100;
                  if (isFloat(Number(compareAtPrice))) {
                    compareAtPrice = Number(compareAtPrice).toFixed(2);
                  }
                  var spanHTML = document.createElement('span');
                  spanHTML.classList.add('render-price-item')
                  spanHTML.innerHTML = `<s class="price-item price-item--regular">$${compareAtPrice}</s>`;
                  elm.appendChild(spanHTML);
                }
              }
            }
          });
        });
      });
    });
  }

  onUpdateFreeItemButton() {
    const ELM_cartItemsWrapper = document.querySelector('cart-items');
    const ELM_cartDrawerItems = document.querySelector('cart-drawer-items');
    const ELM_cartUpsells = document.querySelectorAll('.cart-upsell');
    let ELM_cartItems = null;
    if (ELM_cartItemsWrapper) {
      ELM_cartItems = ELM_cartItemsWrapper.querySelectorAll('.cart-item');
    } else {
      ELM_cartItems = ELM_cartDrawerItems.querySelectorAll('.cart-item');
    }

    let cartItemIds = '';
    if (!ELM_cartUpsells || !ELM_cartItems) return;

    ELM_cartItems.forEach(item => {
      cartItemIds += `${item.dataset.productId}, `;
    });

    ELM_cartUpsells.forEach(upsell => {
      upsell.querySelectorAll('.product-card-wrapper').forEach(item => {
        const productPrice = item.dataset.cardProductPrice;
        const productId = item.dataset.cardProductId;

        if (productPrice <= 0) {
          if (cartItemIds.includes(productId)) {
            item.querySelector('[type="submit"]').setAttribute('disabled', 'true');
          } else {
            item.querySelector('[type="submit"]').removeAttribute('disabled');
          }
        }
      });
    });
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        this.closest('.content-for-layout')?.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
          // this.updateBottlesCollected();
          this.onNotiAddToCart('', parsedState.item_count);
          setTimeout(() => {
            this.onUpdateFreeItemButton();
          }, 1000)
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch((e) => {
        console.error(e);
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        this.onChangeVariantRecommadation();
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        const newBYOBTags = localStorage.getItem('newBYOBTags');

        if(!newBYOBTags) return;
        const changedEvent = new Event('change');
        const textArea = this.querySelector('textarea');
        textArea.value = newBYOBTags.toString();
        setTimeout(() => {
          this.dispatchEvent(changedEvent);
          textArea.dispatchEvent(changedEvent);
        }, 100);

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event?.target?.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
